import { render, staticRenderFns } from "./CompanyTabs.vue?vue&type=template&id=1229c218&"
import script from "./CompanyTabs.vue?vue&type=script&lang=ts&"
export * from "./CompanyTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTabs,QRouteTab,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign({QTabs,QRouteTab,QTabPanels,QTabPanel}, component.options.components || {})
